function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FF6060"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  x: 0.5,
  y: 0.5,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF6060",
  d: "M12.308 4l.692.692L9.192 8.5 13 12.308l-.692.692-3.809-3.808L4.692 13 4 12.308 7.807 8.5 4 4.692 4.692 4 8.5 7.807 12.308 4z"
}));
function SvgIconRejectedBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'%3e %3cg fill='none' fill-rule='evenodd' stroke='%23FF6060'%3e %3crect width='16' height='16' x='.5' y='.5' fill-rule='nonzero' rx='3'/%3e %3cpath fill='%23FF6060' d='M12.308 4l.692.692L9.192 8.5 13 12.308l-.692.692-3.809-3.808L4.692 13 4 12.308 7.807 8.5 4 4.692 4.692 4 8.5 7.807 12.308 4z'/%3e %3c/g%3e %3c/svg%3e";
export { SvgIconRejectedBorder as ReactComponent };